import type { IAccount } from "@apis/accounts/types"
import { PlanTermsTable } from "@components/PlanTermsTable/PlanTermsTable"
import { useComputedAccountCorrespondencesQuery } from "@apis/accounts/useAccounts"
import { correspondenceColumns } from "@components/PlanCorrespondencesTable/tableColumnSchema"
import { DataTable } from "@components/DataTable/DataTable"

type TPlanDetailsProps = {
  plan_data: IAccount
}

export const PlanDetails = ({ plan_data }: TPlanDetailsProps) => {
  const { data, isPending } = useComputedAccountCorrespondencesQuery(
    String(plan_data.account_id),
  )

  return (
    <div className="md:tw:grid-cols-2 lg:tw:grid-cols-3 tw:grid tw:grid-cols-1 tw:gap-4">
      <div>
        <h2 className="tw:mb-2 tw:text-xl">
          Plan Terms ({plan_data.offer_histories?.length ?? 0})
        </h2>
        <PlanTermsTable terms={plan_data.offer_histories} />
      </div>
      <div>
        <h2 className="tw:mb-2 tw:text-xl">
          Correspondence ({data?.length ?? 0})
        </h2>
        <DataTable
          columns={correspondenceColumns}
          data={data ?? []}
          pending={isPending}
          condensed={true}
        />
      </div>
    </div>
  )
}
